import { commentType, commentTypeOptionsMap } from '../model/types';

import QuillGrispiRichTextEditor from './QuillGrispiRichTextEditor';

interface CommentProps {
    content?: string;
    type?: commentType;
    id: number;
    showTranslate?: boolean;
}

const Comment = ({ showTranslate = false, content, type, id }: CommentProps): JSX.Element => {
    return (
        <div className="full-width">
            <QuillGrispiRichTextEditor
                internalView={type === commentTypeOptionsMap.internal}
                key={id}
                readOnly
                value={content}
                showTranslate={showTranslate}
                eventListenerKey={'Comment-' + id.toString()}
            />
        </div>
    );
};

export default Comment;
